import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import image1 from "../../assets/Awardphoto1.png";
import image2 from "../../assets/Awardphoto2.png";
import image3 from "../../assets/Awardphoto3.png";
import image4 from "../../assets/Awardphoto4.png";
import image5 from "../../assets/Awardphoto5.png";
import image6 from "../../assets/images/Frame3.png";
import image7 from "../../assets/images/pfimg1.png";
import image8 from "../../assets/images/Frame11.png";
import image10 from "../../assets/New_data/photo11.jpeg";

const AwardPhotos = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: "ease-in-out",
      once: false,
    });
  }, []);

  return (
    <div className="container mx-auto pt-8">
      {/* Row 1 */}
      <div className="flex flex-col md:flex-row gap-4 mb-4 md:h-[500px]">
        <div
          className="w-full md:w-1/2 flex flex-col gap-4"
          data-aos="fade-up"
          data-aos-delay="100"
        >
          <div className="flex-1 overflow-hidden rounded-lg">
            <img
              src={image3}
              alt="Award ceremony"
              className="w-full h-full object-cover rounded-lg"
            />
          </div>
          <div className="flex-1 overflow-hidden rounded-lg">
            <img
              src={image10}
              alt="Award"
              className="w-full h-full object-fill rounded-lg"
            />
          </div>
        </div>

        <div
          className="w-full md:w-1/2 flex flex-col gap-4"
          data-aos="fade-left"
          data-aos-delay="200"
        >
          <div
            className="flex-1 overflow-hidden rounded-lg"
            data-aos="fade-left"
            data-aos-delay="300"
          >
            <img
              src={image2}
              alt="Award ceremony"
              className="w-full h-full object-cover rounded-lg"
            />
          </div>
          <div className="flex-1 overflow-hidden rounded-lg">
            <img
              src={image1}
              alt="Award ceremony"
              className="w-full h-full object-cover rounded-lg"
            />
          </div>
        </div>
      </div>

      {/* Row 2 */}
      <div className="flex flex-col md:flex-row gap-4 mb-4 md:h-[350px]">
        <div
          className="w-full md:w-1/2 overflow-hidden rounded-lg"
          data-aos="fade-right"
          data-aos-delay="400"
        >
          <img
            src={image4}
            alt="Industrial equipment"
            className="w-full h-full object-cover rounded-lg"
          />
        </div>
        <div
          className="w-full md:w-1/2 overflow-hidden rounded-lg"
          data-aos="fade-left"
          data-aos-delay="500"
        >
          <img
            src={image5}
            alt="Group photo"
            className="w-full h-full object-cover rounded-lg"
          />
        </div>
      </div>

      {/* Row 3 */}
      <div className="flex flex-col md:flex-row gap-4 md:h-[300px]">
        <div
          className="w-full md:w-1/3 overflow-hidden rounded-lg"
          data-aos="fade-right"
          data-aos-delay="400"
        >
          <img
            src={image6}
            alt="Industrial equipment"
            className="w-full h-full object-cover rounded-lg"
          />
        </div>
        <div
          className="w-full md:w-1/3 overflow-hidden rounded-lg"
          data-aos="fade-left"
          data-aos-delay="500"
        >
          <img
            src={image7}
            alt="Group photo"
            className="w-full h-full object-cover rounded-lg"
          />
        </div>
        <div
          className="w-full md:w-1/3 overflow-hidden rounded-lg"
          data-aos="fade-left"
          data-aos-delay="500"
        >
          <img
            src={image8}
            alt="Group photo"
            className="w-full h-full object-cover rounded-lg"
          />
        </div>
      </div>
    </div>
  );
};

export default AwardPhotos;